export const removeDuplicates = (arr: any[]) => {
  return arr.filter((item,
        index) => arr.indexOf(item) === index);
}